/** @jsxImportSource @emotion/react */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { OnboardingContainer } from '../styles';
import { ReplayMessage, ReviewChatWrapper } from './styles';
import { QuestionContent } from '../question/components/question-content';
import { AnswerContent } from '../question/components/answer-content';
import { useReview } from '../../../contexts/review-context';
import { Header, NavTitle } from '../header';

export const OnboardingReviewDetails: React.FC<{ review?: any; onClose?: () => void }> = ({
  review: propReview,
  onClose,
}) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { reviews = [] } = useReview();

  // If a review prop was passed, use that; otherwise resolve via route param
  const review = propReview ?? reviews.find((r: any) => String(r.id) === String(id));

  if (!review) {
    return (
      <OnboardingContainer>
        <Header>
          <NavTitle>Onboarding</NavTitle>
        </Header>
        <ReviewChatWrapper>
          <div>No review found</div>
          <button
            onClick={() => {
              if (onClose) onClose();
              else navigate(-1);
            }}
          >
            Back
          </button>
        </ReviewChatWrapper>
      </OnboardingContainer>
    );
  }

  return (
    <OnboardingContainer>
      <Header
        showBackButton={true}
        onBackNavigate={() => {
          if (onClose) onClose();
          else navigate(-1);
        }}
      >
        <NavTitle>{review.title ? review.title : `Question ${review.step_order}`}</NavTitle>
      </Header>
      <ReviewChatWrapper>
        <QuestionContent
          questionText={review.content}
          audioId={review.audio_id}
        />
        <ReplayMessage>Your reply</ReplayMessage>
        <AnswerContent answerText={review.answer?.content ?? ''} status="read" />
      </ReviewChatWrapper>
    </OnboardingContainer>
  );
};
